import { fetchUtils } from 'react-admin'
import { apiUrl, loginOperationId } from './config/constants'
import { jwtDecode } from 'jwt-decode'

const httpClient = fetchUtils.fetchJson

export const authProvider = {
  // called when the user attempts to log in
  login: async (values) => {
    let token
    let isMFARequired = false
    if ((values.type && values.type === 'wallet') || values.type === 'email') {
      const { signature, digest, email, password } = values

      let payload = { email, password }
      if (values.type === 'wallet') {
        payload = { signature, digest }
      }

      const operationId = loginOperationId(values.type)
      const response = await httpClient(`${apiUrl}/${operationId}`, {
        method: 'POST',
        body: JSON.stringify(payload),
      })
      token = response.json.token
      isMFARequired = response.json.isMFARequired
      // TODO: check on token role (if is admin)
    }

    if (values.type && values.type === '2fa') {
      const operationId = loginOperationId(values.type)
      const response = await httpClient(`${apiUrl}/${operationId}`, {
        method: 'POST',
        body: JSON.stringify({ code: values.code, token: values.token }),
      })
      token = response.json.token
    }
    // { email, password }
    if (isMFARequired) {
      return Promise.reject({ isMFARequired, token })
    }

    localStorage.setItem('auth', token)
    // accept all username/password combinations
    return Promise.resolve()
  },
  // called when the user clicks on the logout button
  logout: () => {
    localStorage.removeItem('auth')
    return Promise.resolve()
  },
  // called when the API returns an error
  checkError: ({ status }) => {
    if (status === 401 || status === 403) {
      localStorage.removeItem('auth')
      return Promise.reject()
    }
    return Promise.resolve()
  },
  // called when the user navigates to a new location, to check for authentication
  checkAuth: () => {
    return localStorage.getItem('auth') ? Promise.resolve() : Promise.reject()
  },
  // called when the user navigates to a new location, to check for permissions / roles
  getPermissions: () => Promise.resolve(),
}

export const buildResourcePermissions = () => {
  const token = localStorage.getItem('auth')
  if (!token) {
    return []
  }

  const decoded = jwtDecode(token)
  const { permissions } = decoded

  const resources = {}
  for (const permission of permissions) {
    const isWrite = permission.includes('-write')
    const isRead = permission.includes('-read')
    const resourceName = permission.replace('-write', '').replace('-read', '')
    resources[resourceName] = resources[resourceName] || {}
    if (isWrite) {
      resources[resourceName].isCreate = true
      resources[resourceName].isEdit = true
      resources[resourceName].isDelete = true
    }
    if (isRead) {
      resources[resourceName].isRead = true
    }
  }

  return resources
}
